import { createClient } from "@supabase/supabase-js";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sheet from 'react-modal-sheet';
import ExploreRepository from "../../repository/ExploreRepository";
import ExploreListItem from "../../shared/components/exploreplaces/ExploreListItem";
import CoorayAppBar, { NavigationButtonType } from "../../shared/components/CoorayAppBar";
import CurationPicker from "../curationpicker/CurationPicker";
import PlaceRepository from "../../repository/PlaceRepository";
import { useRef } from "react";
import ExplorePlaceModal from "../../shared/components/exploreplacemodal/ExplorePlaceModal";
import ExploreListFilterBar from "../../shared/components/exploreplaces/ExploreListFilterBar";
import { boundsToString } from "../../shared/utils/StringUtils";
import ExploreListVerticalFilterBar from "../../shared/components/exploreplaces/ExploreListVerticalFilterBar";
import { AnalyticsEvent } from "../../shared/analytics/AnalyticsEvent";
import ExploreLLMSearchInput from "../../shared/components/exploreplaces/ExploreLLMSearchInput";
import SearchAlternativesModal from "../../shared/components/searchalternativesmodal/SearchAlternativesModal";
import { getCurrentLocation } from "../../shared/utils/LocationUtils";
import { textClassificationHelper } from "../../shared/ai/TextClassificationHelper";
import IpRepository from "../../repository/IpRepository";
import SideNav, { SideNavItem } from "./components/SideNav";
import MiddleNav from "./components/MiddleNav";
import AnalyticsRepository from "../../repository/AnalyticsRepository";
import { sendAction, sendPageView } from "../../shared/utils/AnalyticsUtils";
import { LazyLoadImage } from "react-lazy-load-image-component";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default function SearchPage({analytics, userProfile, onSignOutClick, onRequestToScrollToTop, onExploreClick, onCollectionClick}) {

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const [loadingText, setLoadingText] = useState(null)
    const [overlayLoadingText, setOverlayLoadingText] = useState(null)
    const [isShowingCurationPicker, setIsShowingCurationPicker] = useState(false)
    const [isExplorePlaceModalOpen, setIsExplorePlaceModalOpen] = useState(false)
    const [isUserInterestModalOpen, setIsUserInterestModalOpen] = useState(false)
    const [explorePlaces, setExplorePlaces] = useState([])
    const [pendingSaveExplorePlace, setPendingSaveExplorePlace] = useState(null)
    const [toastMessage, setToastMessage] = useState(null)
    const [currentOffset, setCurrentOffset] = useState(0)
    const [currentSeed, setCurrentSeed] = useState(null)
    const [currentBounds, setCurrentBounds] = useState(null)
    const [viewingExplorePlace, setViewingExplorePlace] = useState(null)
    const [selectedPlace, setSelectedPlace] = useState(null)
    const [searchHistory, setSearchHistory] = useState([])
    const [searchTerm, setSearchTerm] = useState("")
    const [searchAlternatives, setSearchAlternatives] = useState([])
    const navigate = useNavigate()
    const containerRef = useRef(null)
    const lastScrollY = useRef(0)
    const [isShowingNavbar, setIsShowingNavbar] = useState(true)
    const [userCurrentLocation, setUserCurrentLocation] = useState(null)
    const [isModelLoaded, setIsModelLoaded] = useState(false)
    const [ipLocationDetails, setIpLocationDetails] = useState(null)
    const [searchQueryParameters, setSearchQueryParameters] = useState(null)
    const [isEndOfList, setIsEndOfList] = useState(false)
    const [isShowingNoResults, setIsShowingNoResults] = useState(false)
    const [clientGeneratedSearchId, setClientGeneratedSearchId] = useState(null)
    const [searchProgress, setSearchProgress] = useState(null)

    // const loadTensorTextClassificationModel = async () => {
    //     try {
    //         const result = await textClassificationHelper.loadModel();
    //         if (result.success) {
    //             setIsModelLoaded(true);
    //         } else {
    //             console.log(`error loading model ${result.error}`)
    //         }
    //     } catch (err) {
    //         console.log(`error loading model ${err}`)
    //     }
    // };

    useEffect(() => {
        setTimeout(() => {
            setToastMessage(null)
          }, 2000);
    }, [toastMessage])

    useEffect(() => {
        async function getUserCurrentLocation() {
            const status = await navigator.permissions.query({ name: 'geolocation' });
            if (status.state === 'granted') {
                getCurrentLocation().then((coords) => {
                    setUserCurrentLocation(coords)
                })
            }
        }

        async function getIpLocationDetails() {
            const ipRepository = new IpRepository()
            const ipLocationDetails = await ipRepository.getIpLocationDetails()
            setIpLocationDetails(ipLocationDetails)
        }

        getUserCurrentLocation()
        getIpLocationDetails()

    }, [])

    useEffect(() => {
        sendPageView(analytics, AnalyticsEvent.SEARCH_PAGE_VIEW)
    }, [])
  
    useEffect(() => {
        let timer;
        if (clientGeneratedSearchId) {
            // Initial check
            getExploreSearchProgress(clientGeneratedSearchId);
            
            // Set up periodic checks every second
            timer = setInterval(() => {
                console.log(`getting search progress`)
                getExploreSearchProgress(clientGeneratedSearchId);
            }, 1000);
        }

        // Cleanup function to clear timer when clientGeneratedSearchId changes or becomes null
        return () => {
            if (timer) {
                console.log(`clearing search progress timer`)
                clearInterval(timer);
            }
        };
    }, [clientGeneratedSearchId])

    async function getExploreSearchProgress(clientSearchId) {
        const exploreRepository = new ExploreRepository()
        const progress = await exploreRepository.getExploreSearchProgress(clientSearchId)
        // console.log(`search progress ${JSON.stringify(progress)}`)
        if (progress && loadingText) {
            setSearchProgress(progress.searchHistory.extractedParameters)
        }
    }

    async function getExplorePlacesByTags(newSearchTerm, placeCenter, bounds, shouldReset = false, currentLocation = null, extractedSearchQueryParameters = null, clientSearchId = null) {
        setIsEndOfList(false)
        setLoadingText("Loading ...")
        setSearchProgress(null)
        if (shouldReset) {
            setExplorePlaces([])
        }
        const {
            data: { user },
        } = await supabase.auth.getUser()
        if (user == null) {
            navigate("/login", {replace: true})
        } else {
            const exploreRepository = new ExploreRepository()
            try {

                const googlePlaceId = placeCenter ? placeCenter.key : null
                const placeName = placeCenter ? placeCenter.label : null
                const seed = shouldReset ? null : currentSeed
                const offset = shouldReset ? 0 : currentOffset
                const existing = shouldReset ? [] : explorePlaces
                const userLocation = currentLocation ? currentLocation : userCurrentLocation
                const term = newSearchTerm ?? searchTerm
                const searchParameters = shouldReset ? null : (extractedSearchQueryParameters ? extractedSearchQueryParameters : searchQueryParameters)
                console.log(`currentLocation before calling repo ${JSON.stringify(currentLocation)}`)
                const explorePlacesResponse = await exploreRepository.getExploreSearch(term, offset, seed, googlePlaceId, bounds ? boundsToString(bounds) : null, placeName, userLocation, ipLocationDetails? `${ipLocationDetails.city}, ${ipLocationDetails.country}`: undefined, searchParameters, clientSearchId)

                console.log(`explorePlacesResponse ${JSON.stringify(explorePlacesResponse)}`)

                if (explorePlacesResponse.errorType && explorePlacesResponse.errorType == "MISSING_CURRENT_COORDINATES") {
                    getCurrentLocation().then((coords) => {
                        console.log(`coords ${JSON.stringify(coords)}`)
                        setUserCurrentLocation(coords)
                        getExplorePlacesByTags(newSearchTerm, placeCenter, bounds, shouldReset, coords, searchParameters, clientSearchId)
                    })
                    .catch((err) => {
                        setToastMessage("Please enable location services to search for places.")
                    });
                    return
                }

                if (placeCenter) {
                    setSelectedPlace(placeCenter)
                }

                setIsEndOfList(explorePlacesResponse.isEndOfResults)
                setExplorePlaces(
                    existing.concat(
                        explorePlacesResponse.places.map((place) => {
                            return {
                                ...place, 
                                score: explorePlacesResponse.googlePlaceIdToGoogleReviewScore[place.googlePlaceId],
                                fullAddress: explorePlacesResponse.googlePlaceIdToFullAddress[place.googlePlaceId],
                                distance: explorePlacesResponse.googlePlaceIdToKmDistance[place.googlePlaceId],
                                consolidatedReview: explorePlacesResponse.googlePlaceIdToConsolidatedReview[place.googlePlaceId] ?? place.summary ,
                                images: explorePlacesResponse.googlePlaceIdToImages[place.googlePlaceId],
                                reviewScore: explorePlacesResponse.googlePlaceIdToGoogleReviewScore[place.googlePlaceId],
                                mapLink: explorePlacesResponse.googlePlaceIdToMapsUrl[place.googlePlaceId],
                                recommendedItems: place.recommendedItems.map((item) => {
                                    return {
                                        ...item,
                                        isHighlighted: explorePlacesResponse.relevantTags.includes(item.cleanLabel)
                                    }
                                }),
                                tags: place.tags.map((tag) => {
                                    return {
                                        ...tag,
                                        isHighlighted: explorePlacesResponse.relevantTags.includes(tag.cleanLabel.toLowerCase())
                                    }
                                }),
                                mentioningSites: place.mentioningSites.map((mentioningSite) => {
                                    return {
                                        ...mentioningSite,
                                        title: explorePlacesResponse.mentioningSiteUrlToTitle[mentioningSite.url]
                                    }
                                }),
                                hotScore: explorePlacesResponse.explorePlaceIdToHotScore[place.id] ?? 0,
                                reservationUrl: explorePlacesResponse.googlePlaceIdToReservationLink[place.googlePlaceId]
                            }
                        })
                    )
                )
                setCurrentOffset(explorePlacesResponse.offset)
                setCurrentSeed(explorePlacesResponse.seed)
                setCurrentBounds(explorePlacesResponse.bounds)
                setSearchAlternatives(explorePlacesResponse.missingCategoriesItems.map((item) => {
                    return {
                        label: item.missingCategory,
                        options: item.suggestedCategories
                    }
                }))
                setSearchQueryParameters(explorePlacesResponse.extractedSearchQueryParameters)
                setLoadingText(null)
                setSearchProgress(null)
                setIsShowingNoResults((existing.length + explorePlacesResponse.places.length) == 0)
                setClientGeneratedSearchId(null)
            } catch(e) {
                console.log(`get explore places error ${e}`)
            }
        }
    }

    async function saveExplorePlaceToCuration(googlePlaceId, curationId) {
        setOverlayLoadingText("Saving ...")
        const {
            data: { user },
        } = await supabase.auth.getUser()
        if (user == null) {
            navigate("/login", {replace: true})
        } else {
            const placeRepository = new PlaceRepository()
            try {
                placeRepository.quickSave(curationId, googlePlaceId)
                setOverlayLoadingText(null)
                setToastMessage("Place saved to collection!")
            } catch(e) {
                console.log(`get explore places error ${e.response.status}`)
            }
        }
    }

    function onLoadMoreClick() {
        sendAction(analytics, AnalyticsEvent.SEARCH_LIST_BOTTOM_HIT, AnalyticsEvent.SEARCH_PAGE_VIEW)
        getExplorePlacesByTags(searchTerm, selectedPlace, currentBounds, false, null)
    }

    function onSearchInputEntered(searchInput) {
        console.log(`searchInput ${searchInput}`)
        // console.log(`save clicked ${searchTerm}`)
        // setSearchTerm(searchTerm)
        // getExplorePlacesByTags(searchTerm, selectedPlace, currentBounds, true)
        console.log(`searchTerm ${searchTerm}`)
        setIsShowingNoResults(false)
        if (searchInput.length > 0) {
            sendAction(analytics, AnalyticsEvent.SEARCH_SUBMIT_CLICK, AnalyticsEvent.SEARCH_PAGE_VIEW)
            setSearchTerm(searchInput)
            // getReply(searchTerm)     
            window.scrollTo({ top: 0, behavior: 'smooth' });
            const clientSearchId = crypto.randomUUID()
            setClientGeneratedSearchId(clientSearchId)
            getExplorePlacesByTags(searchInput, selectedPlace, null, true, null, null, clientSearchId)
        } else {
            setSearchTerm("")
            setExplorePlaces([])
        }
    }

    function onClearClick() {
        sendAction(analytics, AnalyticsEvent.SEARCH_CLEAR_CLICK, AnalyticsEvent.SEARCH_PAGE_VIEW)
        setIsShowingNoResults(false)
        setSearchTerm("")
        setExplorePlaces([])
    }

    const handleScroll = () => {
        const div = containerRef.current;
        if (!div) return;
    
        const { scrollTop, scrollHeight, clientHeight } = div;
        if (scrollTop + clientHeight >= scrollHeight - 50 && !loadingText && !isEndOfList) {
            console.log("load more")
            onLoadMoreClick()
        }

        if (scrollTop > lastScrollY.current && scrollTop > 100) {
            // Scrolling down
            console.log(`scrolling down`)
            setIsShowingNavbar(false);
          } else if (scrollTop < lastScrollY.current) {
            // Scrolling up
            console.log(`scrolling up`)
            setIsShowingNavbar(true);
          }
          lastScrollY.current = scrollTop
    };

    // async function getReply(searchTerm) {
    //     const messages = [
    //         { 
    //             role: "system", 
    //             content: "You are a helpful assistant that segments search queries types. Always respond with a valid JSON object in the format of {\"dietaryRequirements\": [...], \"cuisine\": [...], \"location\": [...], \"specificMenuItems\": [...], \"restaurantSettings\": [...]} where each array contains strings. If any of the types are not applicable, respond with an empty array. Do not generate text that is not from the original query. Examples: 1) 'good korean food restaurants in downtown' -> {\"dietaryRequirements\": [], \"cuisine\": [\"korean\"], \"location\": [\"downtown\"], \"specificMenuItems\": [], \"restaurantSettings\": []} 2) 'vegetarian places that serve ramen' -> {\"dietaryRequirements\": [\"vegetarian\"], \"cuisine\": [], \"location\": [], \"specificMenuItems\": [\"ramen\"], \"restaurantSettings\": []} 3) 'romantic outdoor japanese restaurants' -> {\"dietaryRequirements\": [], \"cuisine\": [\"japanese\"], \"location\": [], \"specificMenuItems\": [], \"restaurantSettings\": [\"romantic\", \"outdoor\"]}"
    //         },
    //         { 
    //             role: "user", 
    //             content: `Segment this phrase into types. Text: ${searchTerm}` 
    //         }
    //     ];
        
    //     const reply = await engine.chat.completions.create({
    //         messages,
    //         response_format: { type: "json_object" },
    //         temperature: 0.1
    //     });        
    //     console.log(`reply ${JSON.stringify(reply)}`)

    //     const types = JSON.parse(reply.choices[0].message.content)
    //     console.log(`types ${JSON.stringify(types)}`)
    // }

    return (
        <div className="drawer h-full">
        <input id="my-drawer-3" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content flex flex-col h-full max-h-full overflow-y-hidden">
        <div className="flex flex-col relative h-full max-h-full overflow-y-hidden">
            {
                <div className={`navbar bg-base-100 fixed z-20 gap-2 md:hidden transition-[top] duration-300 ${isShowingNavbar ? 'top-0' : 'top-[-4rem]' }`}>
                <div className="items-center flex flex-row pl-4">
                    {/* <label htmlFor="my-drawer-3" aria-label="open sidebar" className="btn btn-square btn-ghost">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            className="inline-block h-6 w-6 stroke-neutral-content"
                        >
                            <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4 6h16M4 12h16M4 18h16"
                            ></path>
                        </svg>
                    </label> */}
                    <img className="w-8 h-8" src="https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/cooray-shared-resources/roambear_logo.png"/>
                </div>
                <div className="flex-1 flex justify-center">
                </div>
                <div className="absolute left-1/2 -translate-x-1/2">
                    <MiddleNav 
                        selectedItem={SideNavItem.SEARCH} 
                        onExploreClick={onExploreClick} 
                        onSearchClick={() => {}} 
                        onCollectionClick={onCollectionClick}
                    />
                </div>
                {
                    userProfile && <div className="flex-none">
                    <div className="dropdown dropdown-end md:pl-4">
                        <div tabIndex="0" role="button" className="btn btn-ghost btn-circle avatar">
                            <div className="w-10 rounded-full border-4 border-primary flex">
                            { userProfile.user.profilePicture && <img src={  userProfile.user.profilePicture } /> }
                            { !userProfile.user.profilePicture && <span className="text-lg self-center w-full">{ userProfile.user.name[0] }</span> }
                            </div>
                            
                            {/* <div className="avatar placeholder w-10 h-10">
                            <div className="bg-neutral text-neutral-content rounded-full w-10 h-10">
                                <span className="text-xl">AI</span>
                            </div>
                            </div> */}
                        </div>
                        <ul tabIndex="0" className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
                            <li onClick={() => {
                                console.log(`view own profile click ${analytics}`)
                                sendAction(analytics, AnalyticsEvent.VIEW_OWN_PROFILE_CLICK, AnalyticsEvent.SEARCH_PAGE_VIEW, {})
                                window.location.href = "/profile"
                            }}>
                            <div className="py-4">
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_429_11217)">
                                    <path className="stroke-base-content" d="M4 18C4 15.7908 5.79086 14 8 14H16C18.2091 14 20 15.7908 20 18V18C20 19.1045 19.1046 20 18 20H6C4.89543 20 4 19.1045 4 18V18Z" strokeWidth="2.5" strokeLinejoin="round"/>
                                    <circle cx="12" cy="6.99997" r="3" strokeWidth="2.5" className="stroke-base-content"/>
                                    </g>
                                </svg>
                                <span className="text-base">View Profile</span>
                                </div>
                            </li>
                            <li onClick={() => {
                                sendAction(analytics, AnalyticsEvent.VIEW_OWN_PROFILE_INTERESTS_CLICK, AnalyticsEvent.SEARCH_PAGE_VIEW, {})
                                window.location.href = "/profile/interests"
                            }}>
                            <div className="py-4">
                            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path className="stroke-base-content" d="M15.7 4C18.87 4 21 6.98 21 9.76C21 15.39 12.16 20 12 20C11.84 20 3 15.39 3 9.76C3 6.98 5.13 4 8.3 4C10.12 4 11.31 4.91 12 5.71C12.69 4.91 13.88 4 15.7 4Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <span className="text-base">Update Interests</span>
                                </div>
                            </li>
                            <li>
                                <div className="py-4" onClick={() => { 
                                    sendAction(analytics, AnalyticsEvent.LOGOUT_CLICK, AnalyticsEvent.SEARCH_PAGE_VIEW)
                                    onSignOutClick()
                                }}>
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="fill-base-content" d="M12.9999 2C10.2385 2 7.99991 4.23858 7.99991 7C7.99991 7.55228 8.44762 8 8.99991 8C9.55219 8 9.99991 7.55228 9.99991 7C9.99991 5.34315 11.3431 4 12.9999 4H16.9999C18.6568 4 19.9999 5.34315 19.9999 7V17C19.9999 18.6569 18.6568 20 16.9999 20H12.9999C11.3431 20 9.99991 18.6569 9.99991 17C9.99991 16.4477 9.55219 16 8.99991 16C8.44762 16 7.99991 16.4477 7.99991 17C7.99991 19.7614 10.2385 22 12.9999 22H16.9999C19.7613 22 21.9999 19.7614 21.9999 17V7C21.9999 4.23858 19.7613 2 16.9999 2H12.9999Z"/>
                                <path className="fill-base-content" d="M13.9999 11C14.5522 11 14.9999 11.4477 14.9999 12C14.9999 12.5523 14.5522 13 13.9999 13V11Z"/>
                                <path className="fill-base-content" d="M5.71783 11C5.80685 10.8902 5.89214 10.7837 5.97282 10.682C6.21831 10.3723 6.42615 10.1004 6.57291 9.90549C6.64636 9.80795 6.70468 9.72946 6.74495 9.67492L6.79152 9.61162L6.804 9.59454L6.80842 9.58848C6.80846 9.58842 6.80892 9.58778 5.99991 9L6.80842 9.58848C7.13304 9.14167 7.0345 8.51561 6.58769 8.19098C6.14091 7.86637 5.51558 7.9654 5.19094 8.41215L5.18812 8.41602L5.17788 8.43002L5.13612 8.48679C5.09918 8.53682 5.04456 8.61033 4.97516 8.7025C4.83623 8.88702 4.63874 9.14542 4.40567 9.43937C3.93443 10.0337 3.33759 10.7481 2.7928 11.2929L2.08569 12L2.7928 12.7071C3.33759 13.2519 3.93443 13.9663 4.40567 14.5606C4.63874 14.8546 4.83623 15.113 4.97516 15.2975C5.04456 15.3897 5.09918 15.4632 5.13612 15.5132L5.17788 15.57L5.18812 15.584L5.19045 15.5872C5.51509 16.0339 6.14091 16.1336 6.58769 15.809C7.0345 15.4844 7.13355 14.859 6.80892 14.4122L5.99991 15C6.80892 14.4122 6.80897 14.4123 6.80892 14.4122L6.804 14.4055L6.79152 14.3884L6.74495 14.3251C6.70468 14.2705 6.64636 14.1921 6.57291 14.0945C6.42615 13.8996 6.21831 13.6277 5.97282 13.318C5.89214 13.2163 5.80685 13.1098 5.71783 13H13.9999V11H5.71783Z"/>
                                </svg>
                                <span className="text-base">Logout</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                }
            </div>
            }
            <div className="flex flex-row flex-1 overflow-y-hidden">
                {
                    userProfile && <SideNav
                        selectedItem={SideNavItem.SEARCH}
                        userProfile={userProfile}
                        onExploreClick={onExploreClick}
                        onSearchClick={() => {}}
                        onCollectionClick={onCollectionClick}
                        onSignOutClick={onSignOutClick}
                        analytics={analytics}
                    />
                }
                <div className="flex flex-col flex-1 relative max-h-full overflow-y-hidden">
                    <div className="bg-base-100 flex flex-col flex-1 overflow-y-scroll gap-4 px-0 pb-32 pt-16 md:pt-4 items-stretch place-items-stretch" onScroll={handleScroll} ref={containerRef}>
                        {
                            searchTerm.length == 0 && explorePlaces.length == 0 && <div className="flex flex-col items-center justify-center p-4 h-full">
                                <img className="w-40 h-40" src="https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/cooray-shared-resources/roambear-search-logo.png"/>
                                <div className="text-base-content text-center">
                                    Search for a restaurant, a dish,or something like<br/><span className="font-titan">'good coffee in tiong bahru'</span>
                                </div>
                            </div>
                        }
                        {
                            searchTerm.length > 0 && isShowingNoResults && <div className="flex flex-col items-center justify-center p-4 h-full">
                                <img className="w-32 h-32" src="https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/cooray-shared-resources/image-not-found.png"/>
                                <div className="text-base-content text-center pt-2">
                                    Sorry, we couldn't find any results for '<span className="font-bold">{searchTerm}</span>'.<br/>Please try again with different keywords.
                                </div>
                            </div>
                        }
                        {
                            explorePlaces.map((place, index) => {
                                return <div key={place.googlePlaceId} className="md:px-0 flex flex-col items-center justify-center w-full">
                                    {
                                        index % 10 == 1 && /iPhone|iPod/i.test(userAgent) && <div className="text-base-content text-center flex flex-col items-center justify-center h-80 relative md:rounded-md">
                                        <a href="https://apps.apple.com/us/app/roambear-bookmark-places/id6741089867" target="_blank" className="absolute bottom-4 left-1/2 -translate-x-1/2">
                                            <button className="btn btn-lg text-lg btn-primary normal-case rounded-full min-w-max drop-shadow-2xl">
                                            <svg className="fill-primary-content w-5 h-5"  viewBox="0 0 512 512">
                                            <g id="7935ec95c421cee6d86eb22ecd114eed">

                                            <path d="M248.644,123.476c-5.45-29.71,8.598-60.285,25.516-80.89
                                                    c18.645-22.735,50.642-40.17,77.986-42.086c4.619,31.149-8.093,61.498-24.826,82.965
                                                    C309.37,106.527,278.508,124.411,248.644,123.476z M409.034,231.131c8.461-23.606,25.223-44.845,51.227-59.175
                                                    c-26.278-32.792-63.173-51.83-97.99-51.83c-46.065,0-65.542,21.947-97.538,21.947c-32.96,0-57.965-21.947-97.866-21.947
                                                    c-39.127,0-80.776,23.848-107.19,64.577c-9.712,15.055-16.291,33.758-19.879,54.59c-9.956,58.439,4.916,134.557,49.279,202.144
                                                    c21.57,32.796,50.321,69.737,87.881,70.059c33.459,0.327,42.951-21.392,88.246-21.616c45.362-0.258,53.959,21.841,87.372,21.522
                                                    c37.571-0.317,67.906-41.199,89.476-73.991c15.359-23.532,21.167-35.418,33.11-62.023
                                                    C414.435,352.487,389.459,285.571,409.034,231.131z">

                                            </path>

                                            </g>

                                            </svg> Get the iPhone App
                                            </button>
                                        </a>
                                        <LazyLoadImage 
                                        className="rounded-md h-full" 
                                        src={"https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/cooray-shared-resources/roambear-download-ios-banner.png"}
                                        />
                                        <div class="h-56 w-full bg-linear-to-b from-transparent to-base-200"></div>
                                        </div>
                                    }
                                    <div className="w-full">
                                    <ExploreListItem
                                        placeItem={place}
                                        onAddClick={() => { 
                                            setPendingSaveExplorePlace(place)
                                            setIsShowingCurationPicker(true) 
                                            sendAction(analytics, AnalyticsEvent.SEARCH_SAVE_TO_COLLECTION_CLICK, AnalyticsEvent.SEARCH_PAGE_VIEW)
                                        }}
                                        clickEvent={() => {
                                            setViewingExplorePlace(place)
                                            setIsExplorePlaceModalOpen(true)
                                            sendAction(analytics, AnalyticsEvent.SEARCH_CLICK_TO_VIEW_DETAILS_CLICK, AnalyticsEvent.SEARCH_PAGE_VIEW)
                                        }}
                                    />
                                    </div>
                                    
                                </div>
                            })
                        }
                        {searchTerm.length > 0 && loadingText && !searchProgress && 
                        <div className='col-span-3 md:col-span-6 flex flex-col items-center justify-center pt-4'>
                            <div className="loading loading-infinity loading-lg"></div>
                            <div className='font-normal text-base-content mt-2'>{loadingText}</div>
                        </div>
                        }
                        {searchTerm.length > 0 && loadingText && searchProgress &&
                        <div className='col-span-3 md:col-span-6 flex flex-col items-center justify-center pt-4 px-4'>
                            <div className="loading loading-infinity loading-lg"></div>
                            <div className='font-normal text-base-content mt-2 flex flex-wrap gap-2 items-center justify-center'><span>Searching for </span>
                                {
                                    searchProgress.tags.map((tag) => {
                                        return <div className="badge badge-primary px-2">{tag}</div>
                                    })
                                }
                                {
                                    searchProgress.locations && searchProgress.locations.map((location) => {
                                        return <div className="badge badge-secondary px-2">📍 {location}</div>
                                    })
                                }
                                {
                                    searchProgress.extractedEstablishmentName && <div className="badge badge-secondary px-2">🏠 {searchProgress.extractedEstablishmentName}</div>
                                }
                            </div>
                        </div>
                        }
                        {/* { !loadingText && explorePlaces.length > 0 && !isEndOfList && <div className='col-span-3 md:col-span-6 flex flex-col items-center justify-center'>
                            <button className="btn btn-secondary normal-case text-base" onClick={() => { onLoadMoreClick() }}>Load more</button></div> } */}
                        { !loadingText && explorePlaces.length > 0 && isEndOfList && <div className='col-span-3 md:col-span-6 flex flex-col items-center justify-center'>
                            <div className='font-normal text-base-content mt-2'>🫣No more results</div>
                        </div> }
                    </div>
                    <div className="btm-nav absolute py-4 px-4 md:px-8 md:px-4 md:mr-4 bg-neutral rounded-t-3xl h-auto shadow-lg">
                        <ExploreLLMSearchInput 
                        searchInput={searchTerm}
                        onSaveClick={(searchTerm) => {
                            onSearchInputEntered(searchTerm)
                            // classifyText(searchTerm)
                        }}
                        onClearClick={onClearClick}
                        onFocus={() => {
                            // Scroll to bottom when input is focused to ensure it's visible above keyboard
                            setTimeout(() => {
                                window.scrollTo(0, document.body.scrollHeight);
                            }, 100);
                        }}
                        />
                    </div>
                </div>
            </div>
            {overlayLoadingText &&
                <div className='w-full h-full fixed top-0 flex flex-col items-center justify-center backdrop-blur-sm bg-base-100/30'>
                    <div className="loading loading-infinity loading-lg"></div>
                    <div className='font-normal text-base-content mt-2'>{overlayLoadingText}</div>
                </div>
            }
            {
                toastMessage && <div className="toast z-10">
                <div className="alert alert-info">
                <span className="text-sm">{toastMessage}</span>
                </div>
            </div>
            }
            {
                isExplorePlaceModalOpen && viewingExplorePlace && <ExplorePlaceModal 
                    isExplorePlaceModalOpen={isExplorePlaceModalOpen}
                    placeItem={viewingExplorePlace}
                    onExplorePlaceModalDismiss={() => {
                        setIsExplorePlaceModalOpen(false)
                    }}
                    onReserveClick={() => {
                        sendAction(analytics, AnalyticsEvent.DETAILS_RESERVE_CLICK, AnalyticsEvent.SEARCH_PAGE_VIEW, {
                            place_id: viewingExplorePlace.id
                        })
                        window.open(viewingExplorePlace.reservationUrl, "_blank")
                    }}
                    onSaveToCollectionClick={() => {
                        setIsExplorePlaceModalOpen(false)
                        setPendingSaveExplorePlace(viewingExplorePlace)
                        setIsShowingCurationPicker(true) 
                        sendAction(analytics, AnalyticsEvent.SEARCH_DETAIL_SAVE_TO_COLLECTION_CLICK, AnalyticsEvent.SEARCH_PAGE_VIEW)
                    }}
                    onNavigateClick={() => {
                        sendAction(analytics, AnalyticsEvent.DETAILS_GOOGLE_NAVIGATE_CLICK, AnalyticsEvent.EXPLORE_SEARCH_DETAILS_VIEW, {
                            place_id: viewingExplorePlace.id
                        })
                        window.open(viewingExplorePlace.mapLink, "_blank")
                    }}
                />
            }
            {
                <Sheet isOpen={isShowingCurationPicker} onClose={() => {setIsShowingCurationPicker(false)}} onOpenEnd={() => {}} detent="content-height">
                <Sheet.Container>
                <Sheet.Header />
                <Sheet.Content>
                <CoorayAppBar 
                title={ "Pick a collection" }
                onBackPressed={() => {
                    setIsShowingCurationPicker(false)  
                }}
                navigationType={NavigationButtonType.Close}
                />
                <Sheet.Scroller draggableAt="both">
                    <CurationPicker
                    shouldShowTitleAppBar={false}
                    analytics={analytics}
                    onPickerBackPressed={() => {}}
                    onPickerCurationSelected={(curationId, curationName) => {
                        // onAddToAnotherCollectionSelected(curationId, curationName)
                        // getCurations(curationId)
                        if (pendingSaveExplorePlace) {
                            setIsShowingCurationPicker(false)
                            saveExplorePlaceToCuration(pendingSaveExplorePlace.googlePlaceId, curationId)
                            sendAction(analytics, AnalyticsEvent.SEARCH_SAVE_COLLECTION_SELECTED, AnalyticsEvent.SEARCH_PAGE_VIEW)
                        }
                    }}
                />
                </Sheet.Scroller>
                </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onTap={(_) => {
                    setIsShowingCurationPicker(false)
                }}/>
            </Sheet>
            }
            {/* {
                <ExploreUserInterestModal 
                    isUserInterestModalOpen={isUserInterestModalOpen}
                    onUserInterestModalDismiss={() => {
                        setIsUserInterestModalOpen(false)
                        getExplorePlacesByTags(selectedPlace, currentBounds, true)
                    }}
                />
            } */}
            {
                searchAlternatives.length > 0 && <SearchAlternativesModal 
                    alternatives={searchAlternatives}
                    isSearchAlternativesModalOpen={searchAlternatives.length > 0}
                    onSearchAlternativesModalDismiss={() => {
                        setSearchAlternatives([])
                    }}
                    onApplyClick={(selectedAlternatives) => {
                        let newSearchTerm = searchTerm
                        Object.keys(selectedAlternatives).forEach((key) => {
                            if (selectedAlternatives[key]) {
                                newSearchTerm = newSearchTerm.replace(new RegExp(key, 'i'), selectedAlternatives[key].label)
                            }
                        })
                        console.log(`newSearchTerm ${newSearchTerm}`)
                        // setToastMessage(newSearchTerm)
                        onSearchInputEntered(newSearchTerm)
                    }}  
                />
            }
        </div>
        </div>
        <div className="drawer-side z-20">
            <label htmlFor="my-drawer-3" aria-label="close sidebar" className="drawer-overlay"></label>
            <ul className="menu bg-base-200 min-h-full w-80 p-4 gap-2">
            <li>
                <img 
                className="h-16 w-auto" 
                src="https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/cooray-shared-resources/logos/roambear-full-logo-two-colors.png" />
            </li>
            <li><a>
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className="stroke-neutral-content" d="M16.6725 16.6412L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span className="text-base font-bold">Search</span>
            </a></li>
            <li onClick={() => {
                onExploreClick()
            }}><a>
                <svg className="fill-neutral-content/50 w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M17.9842695,7.39078625 C18.1985588,6.64477525 17.4973604,5.9435768 16.7513494,6.1578661 L16.6494246,6.19284365 L9.57835679,9.02127078 L9.47282273,9.07079854 C9.30957453,9.15937167 9.17428758,9.29167162 9.08209683,9.45256344 L9.02127078,9.57835679 L6.19284365,16.6494246 L6.1578661,16.7513494 C5.9435768,17.4973604 6.64477525,18.1985588 7.39078625,17.9842695 L7.49271102,17.949292 L14.5637788,15.1208648 L14.6693129,15.0713371 C14.8325611,14.982764 14.967848,14.850464 15.0600388,14.6895722 L15.1208648,14.5637788 L17.949292,7.49271102 L17.9842695,7.39078625 Z M12,10 C13.1045695,10 14,10.8954305 14,12 C14,13.1045695 13.1045695,14 12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 Z"/>
                </svg>
                <span className="text-base text-neutral-content/50">Explore</span>
            </a></li>
            <li onClick={() => {
                onCollectionClick()
            }}><a>
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className="fill-neutral-content/50" fillRule="evenodd" clipule="evenodd" d="M5.36129 3.46995C6.03579 3.16081 6.76287 3 7.50002 3C8.23718 3 8.96425 3.16081 9.63875 3.46995C10.3129 3.77893 10.9185 4.22861 11.4239 4.78788C11.7322 5.12902 12.2678 5.12902 12.5761 4.78788C13.5979 3.65726 15.0068 3.00001 16.5 3.00001C17.9932 3.00001 19.4021 3.65726 20.4239 4.78788C21.4427 5.91515 22 7.42425 22 8.9792C22 10.5342 21.4427 12.0433 20.4239 13.1705L14.2257 20.0287C13.0346 21.3467 10.9654 21.3467 9.77429 20.0287L3.57613 13.1705C3.07086 12.6115 2.67474 11.9531 2.40602 11.2353C2.13731 10.5175 2 9.75113 2 8.9792C2 8.20728 2.13731 7.44094 2.40602 6.72315C2.67474 6.00531 3.07086 5.34694 3.57613 4.78788C4.08157 4.22861 4.68716 3.77893 5.36129 3.46995Z"/>
                </svg>
                <span className="text-base text-neutral-content/50">Collections</span>
            </a></li>
            </ul>
        </div>
        </div>
    )
}
